import { Form, Modal } from 'react-bootstrap';
import { useState } from 'react';
import cn from 'classnames';
import { Button } from '../Button/Button';
import { Appearance, Design } from '../designConstants';

interface RenameModalProps {
  applyOnClick: (newName: string) => void;
  applyText: string;
  cancelText: string;
  disabled?: boolean | ((newName: string) => boolean);
  disabledText?: string;
  onCancel: () => void;
  onHide: () => void;
  placeholder: string;
  subTitle: string;
  title: string;
}

export const RenameModal = ({
  applyOnClick,
  applyText,
  cancelText,
  disabled,
  disabledText,
  onCancel,
  onHide,
  placeholder,
  subTitle,
  title
}: RenameModalProps) => {
  const [newName, setNewName] = useState('');
  const isDisabled = typeof disabled === 'function' ? disabled(newName) : disabled;
  return (
    <Modal show centered size='lg' onHide={onHide} className='renameSaveAsNewModal'>
      <Modal.Header>
        <Modal.Title className='renameSaveAsHeader'>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={cn({ 'includes-disabled-text': Boolean(disabledText) })}>
        <div className='renameSaveAsText'>{subTitle}</div>
        <div className='renameSaveAsInputContainer'>
          <Form.Control
            className='renameSaveAsInput'
            onChange={e => setNewName(e.target.value)}
            placeholder={placeholder}
            value={newName}
          />
        </div>
        {disabledText && isDisabled ? (
          <div className='renameSaveAsDisabledText'>{disabledText}</div>
        ) : (
          <div className='renameSaveAsDisabledTextInvisible'>&nbsp;</div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          className='cancel-button'
          appearance={Appearance.OUTLINED}
          design={Design.NEUTRAL}
          onClick={onCancel}
        >
          {cancelText}
        </Button>
        <Button
          className='apply-button'
          disabled={isDisabled}
          onClick={() => applyOnClick(newName)}
        >
          {applyText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
